




















import { Component, Vue, Prop, Watch, Emit, PropSync } from 'vue-property-decorator';
import User, { UserData, UserInfoField } from '@/views/users/Users';
import { namespace } from 'vuex-class';
import { Role } from 'auth0';

const Tenants = namespace('tenants');

@Component({})
export default class UsersTableBody extends Vue {
  
  @Tenants.Action('getRoles')
  private getRoles!: () => Promise<Role[]>
  
  @Prop({ required: false, default: () => new User() }) value!: UserData
  // @Prop({ required: false, default: () => new User() }) data!: UserData
  // @PropSync('data', { type: Object }) data!: UserData
  
  private data: UserData = new User();
  
  @Emit('input')
  @Watch('value', { immediate: false, deep: true })
  onPersonChanged (val: UserData, oldVal: UserData) {
    this.data = val;
    return val
  }
  
  private userInfoFields: { [keyName: string]: UserInfoField } = {
    email: {
      label: 'Email',
      type: 'input',
      validate: 'email|required'
    },
    name: {
      label: 'Name',
      type: 'input',
      validate: 'required'
    }
  }
  
  async created () {
    if (this.$route.params.id) {
      this.userInfoFields = {
        ...this.userInfoFields,
        blocked: {
          label: 'Blocked',
          type: 'switch'
        },
        roles: {
          label: 'Roles(s)',
          type: 'v-select',
          options: {},
          clearable: false,
          multiple: true,
          appendToBody: true
        }
      }
      const roles = await this.getRoles();
      this.userInfoFields['roles'].options = {
        text: 'description',
        items: roles
      }
    }
    
  }
}
